import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

class EnableSettingsEdit {
  static readonly type = '[Settings] Edit Enabled';
  constructor(public payload: { isEditing: true; saveChanges: false }) {}
}

class DisableSettingsEdit {
  static readonly type = '[Settings] Edit Disabled';
}

class SaveSettingsEdit {
  static readonly type = '[Settings] Save Changes';
  constructor(public payload: { saveChanges: true }) {}
}

class UnSavedSettingsEdit {
  static readonly type = '[Settings] UnSaved Changes';
}

interface SettingsEditStateModel {
  isEditing: boolean;
  saveChanges: boolean;
}

@State<SettingsEditStateModel>({
  name: 'settings',
  defaults: { isEditing: false, saveChanges: false },
})
@Injectable()
class SettingsEditState {
  @Selector()
  static getEditState(state: SettingsEditStateModel): boolean {
    return state.isEditing;
  }

  @Selector()
  static getSaveState(state: SettingsEditStateModel): boolean {
    return state.saveChanges;
  }

  @Action(EnableSettingsEdit)
  enable(
    ctx: StateContext<SettingsEditStateModel>,
    action: EnableSettingsEdit
  ) {
    ctx.patchState({ isEditing: action.payload.isEditing });
  }

  @Action(SaveSettingsEdit)
  save(ctx: StateContext<SettingsEditStateModel>, action: SaveSettingsEdit) {
    ctx.patchState({ saveChanges: action.payload.saveChanges });
  }

  @Action(UnSavedSettingsEdit)
  unsaved(ctx: StateContext<SettingsEditStateModel>) {
    ctx.patchState({ saveChanges: false });
  }

  @Action(DisableSettingsEdit)
  disable(ctx: StateContext<SettingsEditStateModel>) {
    ctx.patchState({ isEditing: false, saveChanges: false });
  }
}

export {
  SettingsEditState,
  SettingsEditStateModel,
  EnableSettingsEdit,
  DisableSettingsEdit,
  SaveSettingsEdit,
  UnSavedSettingsEdit,
};
